import React from 'react'
import SensitiveBoundary from './SensitiveBoundary'
import { useVision } from './visionContext'

// Story 213 v2 — the route of a screen of the catalog (DN-3) is a sensitive boundary while the screen is marked,
// as `GET /vision/screens` says (S199, H-v2-19). Unmarked, or with vision off, it renders as today.
const SensitiveScreen = ({ screen, children }) => {
  const { markedScreens } = useVision()
  return <SensitiveBoundary sensitive={markedScreens.includes(screen)}>{children}</SensitiveBoundary>
}

export default SensitiveScreen
